import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import Button from 'components/Atoms/Button';
import EditIcon from '@mui/icons-material/Edit';
import TitleWithText from 'components/Atoms/TitleWithText';
import Typographys from 'components/Atoms/Typography';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import NoRecordsMessage from 'components/Organisms/CommonPageUtils/NoRecordsFound';
import { hasPermission } from 'utils/permissions';
import { useSelector } from 'react-redux';
import { profileStyle } from '../style';

const ProfileEducationalHistory = ({ educationHistory, handleEdit, handleAttachment }) => {
  const authorities = useSelector((state) => state.session.user.authorities);
  const userHasEditPermission = hasPermission(authorities, [
    'ROLE_BASE_PERMISSION_EMPLOYEE_INDEX_UPDATE_MY_EDUCATION_HISTORY',
  ]);

  return (
    <>
      <Box sx={profileStyle.actionBtn}>
        {!!userHasEditPermission && (
          <Button startIcon={<EditIcon fontSize="2.5rem" />} onClick={handleEdit}>
            {educationHistory.length > 0 ? 'Edit' : 'Add'}
          </Button>
        )}
      </Box>

      {educationHistory.length > 0 ? (
        <Box mt={4}>
          {educationHistory.map((educationList) => (
            <Box sx={{ ...profileStyle.divider, mt: 2.5, pt: 2.5 }}>
              <Grid container rowSpacing={1} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Institution Name" text={educationList.institutionName} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Certification Name" text={educationList.certificationName} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Start Date" text={educationList.startDate} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="End Date" text={educationList.endDate} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Specialization" text={educationList.specialization} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Registration Number" text={educationList.registrationNumber} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Reference Name" text={educationList.referenceName} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Reference Phone Number" text={educationList.referencePhone} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TitleWithText title="Registration Email" text={educationList.registrationEmail} />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TitleWithText title="Comments" text={educationList.comment} />
                </Grid>
                <Grid item xs={12} mt={3} mb={1}>
                  <Typographys variant="h6" color="neutral.800">
                    Attachments
                  </Typographys>
                  <Button
                    variant="text"
                    color="secondary"
                    onClick={() => handleAttachment(educationList?.certificateFileId, educationList?.certificateFile)}
                    startIcon={<AttachFileIcon />}
                  >
                    {educationList?.certificateFile || ''}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      ) : (
        <NoRecordsMessage width="20rem" height="20rem" />
      )}
    </>
  );
};

ProfileEducationalHistory.defaultProps = {
  educationHistory: [],
  handleEdit: () => {},
  handleAttachment: () => {},
};

ProfileEducationalHistory.propTypes = {
  educationHistory: PropTypes.arrayOf,
  handleEdit: PropTypes.func,
  handleAttachment: PropTypes.func,
};

export default ProfileEducationalHistory;
